import axios from 'axios';

const test = false;
let baseurl = 'http://192.168.1.50/jnsapi/api/'; // test server
if (test === false) {
  baseurl = 'https://demo.web2.ph/demoinventory/api/api/'; // live server
}

export default axios.create({
  baseURL: baseurl,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  },
});
